module.exports = __webpack_public_path__ + "img/logo-white.5e08884f.png";